export default __webpack_public_path__ + "static/media/Typical Sunday looks like this.f714ced7.mp4";